import { render, staticRenderFns } from "./ProfileBanner.vue?vue&type=template&id=0df861b0"
import script from "./ProfileBanner.vue?vue&type=script&lang=js"
export * from "./ProfileBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports